import React from 'react';

import { Button, Card } from 'antd';

import ComponentBlocker from '@src/components/ComponentBlocker';
import IntlMessages from '@src/util/IntlMessages';

import styles from './styles.module.less';

const ShiftCardOption = ({
  title,
  description,
  onCreate,
  actionLabel,
  icon,
  allowedRoles = null,
}) => {
  const actionButton = (
    <Button type="link" className={styles.createButton} onClick={onCreate}>
      {actionLabel ?? <IntlMessages id="workJourney.create.button" />}
    </Button>
  );

  return (
    <Card className={styles.journeyTypeCard}>
      <div className={styles.cardHeader}>
        <div className={styles.cardTitle}>
          {icon ? (
            <span className={`${styles.cardIcon} material-symbols-outlined`} aria-hidden="true">
              {icon}
            </span>
          ) : null}
          <h3>{title}</h3>
        </div>
        {allowedRoles ? (
          <ComponentBlocker allowedRoles={allowedRoles}>{actionButton}</ComponentBlocker>
        ) : (
          actionButton
        )}
      </div>
      <p className={styles.cardDescription}>{description}</p>
    </Card>
  );
};

export default ShiftCardOption;
